import { AxiosError } from 'axios'
import { ENDPOINT_PROJECT_SETTINGS } from '../config'
import type { ProjectSettingsResponse } from '../types'
import AuthAxios from '@/lib/api/axios/AuthAxios'

const getProjectSettings = async (
  workspaceSlug: string,
  projectId: string,
): Promise<ProjectSettingsResponse> => {
  try {
    const response = await AuthAxios.get<ProjectSettingsResponse>(
      `${ENDPOINT_PROJECT_SETTINGS}/${workspaceSlug}/projects/${projectId}/settings`,
    )
    return response.data
  } catch (error) {
    if (error instanceof AxiosError && error.response?.status === 403) {
      throw new Error('You do not have permission to view settings for this project')
    }
    throw error
  }
}

export default getProjectSettings
